var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgWarningColor = function SvgWarningColor(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    "data-width-24": 16,
    viewBox: "0 0 16 16",
    ref: ref
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#FF974A",
    rx: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M8 3c.265 0 .52.078.707.216.188.138.293.326.293.521v5.526c0 .195-.105.383-.293.521A1.2 1.2 0 0 1 8 10c-.265 0-.52-.078-.707-.216C7.105 9.646 7 9.458 7 9.263V3.737c0-.195.105-.383.293-.521C7.48 3.078 7.735 3 8 3M8 11c.265 0 .52.08.707.22.188.14.293.331.293.53v.62c0 .199-.105.39-.293.53a1.2 1.2 0 0 1-.707.22 1.2 1.2 0 0 1-.707-.22C7.105 12.76 7 12.57 7 12.37v-.62c0-.199.105-.39.293-.53.187-.14.442-.22.707-.22"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgWarningColor);
export default ForwardRef;